import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { Add, Delete, Edit, Save, Close } from "@mui/icons-material";
import Sidebar from "../../components/Sidebar";
import AddNotification from "../../components/Snackbars";
import {
  buscarInformes,
  deletarInforme,
  editarInforme,
  salvarInforme,
} from "../../Services";

//styles
import "./style.css";

const PaginaInicio = () => {
  const admin = sessionStorage.getItem("isAdm") === "true";
  const getDataHoje = () => new Date().toISOString().slice(0, 10);

  const [informes, setInformes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalInformes, setTotalInformes] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [creating, setCreating] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [savingEdit, setSavingEdit] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [novoTexto, setNovoTexto] = useState("");
  const [novaData, setNovaData] = useState(getDataHoje());
  const [editTexto, setEditTexto] = useState("");
  const [editData, setEditData] = useState(getDataHoje());
  const [notification, setNotification] = useState({
    message: "",
    open: false,
    severity: "",
  });

  const normalizeInformes = (itens = []) => {
    return itens
      .map((item, index) => ({
        id: item.id || item._id || `${item.texto}-${index}`,
        texto: item.texto || "",
        data: item.data || null,
      }))
      .sort((a, b) => new Date(b.data || 0) - new Date(a.data || 0));
  };

  const carregarInformes = async (pagina = page + 1, limite = rowsPerPage) => {
    setLoading(true);
    const res = await buscarInformes(pagina, limite);
    setLoading(false);

    if (res.success) {
      const pagination = res.pagination || {};
      const total = Number(pagination.total || 0);
      const paginas = Number(
        pagination.totalPages || (total > 0 ? Math.ceil(total / limite) : 0)
      );

      if (paginas > 0 && pagina > paginas) {
        setPage(paginas - 1);
        return;
      }

      setInformes(normalizeInformes(res.data));
      setTotalInformes(total);
      setTotalPages(paginas);
      return;
    }

    setNotification({
      open: true,
      message: res.message || "Não foi possível carregar os informes.",
      severity: "error",
    });
  };

  useEffect(() => {
    carregarInformes(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

const isRecente = (data) => {
  if (!data) return false;

  const dataInforme = new Date(data);
  if (Number.isNaN(dataInforme.getTime())) return false;

  dataInforme.setHours(0, 0, 0, 0);

  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  const limite = new Date(hoje);
  limite.setDate(hoje.getDate() - 3);

  return dataInforme >= limite;
};

  const formatarData = (data) => {
    if (!data) return "";

    const dataInforme = new Date(data);
    if (Number.isNaN(dataInforme.getTime())) return "";

    return dataInforme.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  };

  const informesExibidos = useMemo(() => normalizeInformes(informes), [informes]);

  const iniciarEdicao = (informe) => {
    setEditingId(informe.id);
    setEditTexto(informe.texto || "");
    setEditData(
      informe.data ? new Date(informe.data).toISOString().slice(0, 10) : getDataHoje()
    );
  };

  const cancelarEdicao = () => {
    setEditingId(null);
    setEditTexto("");
    setEditData(getDataHoje());
  };

  const handleCriar = async () => {
    const texto = novoTexto.trim();

    if (!texto) {
      setNotification({
        open: true,
        message: "Informe o texto do informe.",
        severity: "warning",
      });
      return;
    }

    setCreating(true);
    const res = await salvarInforme({
      texto,
      data: new Date(`${novaData}T00:00:00`).toISOString(),
    });
    setCreating(false);

    if (!res.success) {
      setNotification({
        open: true,
        message: res.msg || "Não foi possível cadastrar o informe.",
        severity: "error",
      });
      return;
    }

    setNovoTexto("");
    setNovaData(getDataHoje());
    setNotification({
      open: true,
      message: res.msg || "Informe cadastrado com sucesso.",
      severity: "success",
    });

    if (page !== 0) {
      setPage(0);
    } else {
      carregarInformes(1, rowsPerPage);
    }
  };

  const handleSalvarEdicao = async () => {
    const texto = editTexto.trim();

    if (!texto || !editingId) {
      setNotification({
        open: true,
        message: "Informe um texto válido para salvar.",
        severity: "warning",
      });
      return;
    }

    setSavingEdit(true);
    const res = await editarInforme(editingId, {
      texto,
      data: new Date(`${editData}T00:00:00`).toISOString(),
    });
    setSavingEdit(false);

    if (!res.success) {
      setNotification({
        open: true,
        message: res.msg || "Não foi possível atualizar o informe.",
        severity: "error",
      });
      return;
    }

    cancelarEdicao();
    setNotification({
      open: true,
      message: res.msg || "Informe atualizado com sucesso.",
      severity: "success",
    });
    carregarInformes(page + 1, rowsPerPage);
  };

  const handleDeletar = async (id) => {
    setDeletingId(id);
    const res = await deletarInforme(id);
    setDeletingId(null);

    if (!res.success) {
      setNotification({
        open: true,
        message: res.msg || "Não foi possível excluir o informe.",
        severity: "error",
      });
      return;
    }

    setNotification({
      open: true,
      message: res.msg || "Informe removido com sucesso.",
      severity: "success",
    });
    carregarInformes(page + 1, rowsPerPage);
  };

  const handleChangePage = (_event, newPage) => {
    if (newPage >= totalPages && totalPages > 0) return;
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <AddNotification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="container-inicio">
        <Sidebar />
        <div className="page-box">
          <div className="inicio-content">
            <Box className="welcome-image" sx={{ textAlign: "center" }}>
              <Typography variant="h4">Seja bem-vindo ao Banco de Preços</Typography>
              <Typography>
                Clique em <b style={{ color: "#1976d2 " }}>Pesquisa de preços</b>{" "}
                para começar!
              </Typography>
            </Box>

            <Paper className="informes-card" elevation={2}>
              <Typography variant="h6" className="informes-title">
                Últimas atualizações
              </Typography>

              {admin ? (
                <Stack className="informes-form" spacing={1}>
                  <TextField
                    size="small"
                    fullWidth
                    label="Texto do informe"
                    value={novoTexto}
                    onChange={(e) => setNovoTexto(e.target.value)}
                  />
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                    <TextField
                      size="small"
                      label="Data"
                      type="date"
                      value={novaData}
                      onChange={(e) => setNovaData(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                    <Button
                      variant="contained"
                      onClick={handleCriar}
                      startIcon={creating ? <CircularProgress size={16} /> : <Add />}
                      disabled={creating}
                    >
                      Adicionar
                    </Button>
                  </Stack>
                </Stack>
              ) : null}

              <TableContainer>
                <Table size="small" className="informe-table">
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={admin ? 2 : 1}>
                          <Box className="informes-loading">
                            <CircularProgress size={20} />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : null}

                    {!loading && informesExibidos.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={admin ? 2 : 1}>
                          Nenhum informe encontrado.
                        </TableCell>
                      </TableRow>
                    ) : null}

                    {!loading &&
                      informesExibidos.map((informe, index) => {
                        const editando = editingId === informe.id;
                        const rowClass = [
                          isRecente(informe.data)
                            ? index % 2 === 0
                              ? "informe-row-recent-light"
                              : "informe-row-recent-dark"
                            : index % 2 === 0
                            ? "informe-row-light"
                            : "informe-row-dark",
                        ]
                          .filter(Boolean)
                          .join(" ");

                        return (
                          <TableRow key={informe.id} className={rowClass}>
                            <TableCell>
                              {editando ? (
                                <Stack spacing={1}>
                                  <TextField
                                    size="small"
                                    fullWidth
                                    label="Texto"
                                    value={editTexto}
                                    onChange={(e) => setEditTexto(e.target.value)}
                                  />
                                  <TextField
                                    size="small"
                                    label="Data"
                                    type="date"
                                    value={editData}
                                    onChange={(e) => setEditData(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                  />
                                </Stack>
                              ) : (
                                <Stack spacing={0.4}>
                                  <Typography
                                    variant="caption"
                                    sx={{ fontSize: "0.67rem", opacity: 0.66 }}
                                  >
                                    {formatarData(informe.data)}
                                  </Typography>
                                  <Typography variant="body2">{informe.texto}</Typography>
                                </Stack>
                              )}
                            </TableCell>
                            {admin ? (
                              <TableCell align="right">
                                {editando ? (
                                  <>
                                    <IconButton
                                      size="small"
                                      onClick={handleSalvarEdicao}
                                      disabled={savingEdit}
                                    >
                                      <Save fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={cancelarEdicao}>
                                      <Close fontSize="small" />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    <IconButton
                                      size="small"
                                      onClick={() => iniciarEdicao(informe)}
                                    >
                                      <Edit fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleDeletar(informe.id)}
                                      disabled={deletingId === informe.id}
                                    >
                                      <Delete fontSize="small" />
                                    </IconButton>
                                  </>
                                )}
                              </TableCell>
                            ) : null}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                className="informes-pagination"
                component="div"
                count={totalInformes}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
                labelRowsPerPage="Itens por página"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                }
              />
            </Paper>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaginaInicio;
